import React, { useRef } from "react";

import { BLOG_SLUG } from "../core/urls";
import BodyText from "./BodyText";
import Box from "./Box";
import Link from "next/link";
import PropTypes from "prop-types";
import ResponsiveImage from "./ResponsiveImage";
import Text from "./Text";
import { useHovered } from "../core/hooks";
import { useViewportContext } from "./ViewportContext";

function BlogGridItem({ slug, title, introCopy, headerImage, published }) {
  const { isTouch } = useViewportContext();
  const ref = useRef(null);
  const hovered = useHovered(ref);

  const hoveredNotTouch = hovered && !isTouch;

  const href = `/${BLOG_SLUG}/${slug}`;

  return (
    <Link href={href} passHref>
      <Box ref={ref} as="a" display="flex" flexDirection="column">
        <Box overflow="hidden" mb={17}>
          <Box
            transition="transform 300ms ease-out"
            transform={
              hoveredNotTouch ? "scale3d(1.05,1.05,1.05)" : "scale3d(1,1,1)"
            }
          >
            <ResponsiveImage
              resizeRule="fill-740x364-c0"
              image={headerImage}
              pb="50%"
            />
          </Box>
        </Box>
        <Box
          display="inline-flex"
          color={hoveredNotTouch ? "pink" : "black"}
          pb={15}
        >
          <Box>
            <h3 className="blog-item-title">
              <span
                className={`blog-item-title-highlight${
                  hoveredNotTouch ? " hovered" : ""
                }`}
              >
                {title}
              </span>
            </h3>
          </Box>
        </Box>
        <BodyText>{introCopy.split(" ").splice(0, 18).join(" ")}...</BodyText>
        {published && (
          <Text
            uppercase
            fontFamily="ibmPlexMono"
            fontSize={12}
            fontWeight={500}
            mt={22}
          >
            {published}
          </Text>
        )}
      </Box>
    </Link>
  );
}

export default BlogGridItem;

BlogGridItem.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  headerImage: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  introCopy: PropTypes.string.isRequired,
  published: PropTypes.string,
};
